/// <amd-module name="Artifacts/Root/components/RestoreModal" />

import { CommandPanel } from "Artifacts/Root/components/CommandPanel";
import { ComponentState } from "Artifacts/Root/Constants";
import { registerModal } from "Artifacts/Root/containers/ModalManager";
import { connectDynamicModules } from "Artifacts/Root/redux";
import { IRootModuleState } from "Artifacts/Root/redux/Contracts";
import { RootModule } from "Artifacts/Root/redux/Module";
import * as Res from "Artifacts/Root/Resources";
import { IPackageVersionIdentity } from "Artifacts/Root/types";
import * as React from "react";
import { connect } from "react-redux";

export interface IRestoreModalProps {
  onDismiss: () => void;
  onRestore: () => void;
  versions: IPackageVersionIdentity[];
}

interface IMapStateToProps {
  componentState: ComponentState;
}

export const RestoreModalId = "RestoreModal";

const RestoreModal: React.FC<IRestoreModalProps & IMapStateToProps> = ({
  onDismiss,
  onRestore,
  versions,
  componentState,
}) => {
  return (
    <CommandPanel
      title={Res.RestoreModal_Title}
      description={Res.RestoreModal_Body_MultiplePackages}
      packages={versions}
      onDismiss={onDismiss}
      onSubmit={onRestore}
      submitButtonComponentState={componentState}
      submitButtonText={Res.RestoreModalButton}
    ></CommandPanel>
  );
};

const mapStateToProps = (state: IRootModuleState): IMapStateToProps => {
  const rootState = state.rootState;
  return {
    componentState: rootState.restoreCommandState,
  };
};

const ConnectedRestoreModal = connectDynamicModules(connect(mapStateToProps)(RestoreModal), [
  RootModule,
]);

registerModal(RestoreModalId, ConnectedRestoreModal);

export { RestoreModal };
